module.exports = __webpack_public_path__ + "img/20.27534b4a.jpg";